import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { InferredProjectInlineCard } from '@atlassian/rovo-platform-ui-components/inferred-project-card';

import type { InferredProjectElementType } from '../types';
import type { ElementRenderer } from './types';

/**
 * Adapter for inferred-project lumina elements.
 *
 * Renders the project name as an inline trigger with an ARI-based hover card
 * (owner, collaborators, recent work). Gated behind
 * `rovo_chat_enable_hover_lumina_inferred_project` for granular rollout on top
 * of the parent `rovo_chat_enable_inline_lumina` gate.
 *
 * Falls back to plain text when the gate is off or attributes are missing.
 */
export const InferredProjectElementAdapter: ElementRenderer = ({ component, cloudId }) => {
	if (!fg('rovo_chat_enable_hover_lumina_inferred_project')) {
		const el = component as InferredProjectElementType;
		return el.attributes?.name ? <span>{el.attributes.name}</span> : null;
	}

	const el = component as InferredProjectElementType;
	const ari = el.attributes?.ari;
	const name = el.attributes?.name;

	if (!ari || !name) {
		return name ? <span>{name}</span> : null;
	}

	return (
		<InferredProjectInlineCard
			cloudId={cloudId}
			projectId={ari}
			projectName={name}
			fallback={<span>{name}</span>}
		/>
	);
};
